// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2qKRY","disabled":"FileBtn_disabled__sq8O1","warn":"FileBtn_warn__3Nsym","fade":"FileBtn_fade__1YSrK"};